import {
    ButtonNew,
    Input,
    LuneThemeNew,
    LuneThemeProvider,
    Modal,
    Text,
} from '@lune-fe/lune-ui-lib'
import Stack from '@mui/material/Stack'
import { FC, useState } from 'react'

const SaveTemplateModal: FC<{
    modalOpen: boolean
    onModalClose: (mappingName?: string) => void
    isUploading: boolean
    defaultValue?: string
}> = ({ modalOpen, onModalClose, isUploading, defaultValue }) => {
    const { palette } = LuneThemeNew
    const [name, setName] = useState<string>(defaultValue ?? '')

    return (
        <LuneThemeProvider theme={LuneThemeNew}>
            <Modal
                maxWidth={'sm'}
                fullWidth
                open={modalOpen}
                onClose={() => onModalClose()}
                header={<Text variant={'h5'}>{defaultValue ? 'Update' : 'Save'} Mapping</Text>}
                subheader={
                    <Text variant={'body3'} sx={{ color: palette.Grey600 }}>
                        Calculate emissions and save this mapping to reuse in the future
                    </Text>
                }
                actions={
                    <>
                        <ButtonNew style={'outline'} onClick={() => onModalClose()}>
                            Cancel
                        </ButtonNew>
                        <ButtonNew
                            loading={isUploading}
                            onClick={() => {
                                if (isUploading) return
                                onModalClose(name)
                            }}
                            disabled={!name}
                        >
                            {defaultValue === undefined ? 'Calculate emissions' : 'Update mapping'}
                        </ButtonNew>
                    </>
                }
            >
                <Stack
                    direction="column"
                    sx={{
                        width: '100%',
                    }}
                    spacing={{
                        xs: 6,
                    }}
                >
                    <Input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder={'Mapping name'}
                    />
                </Stack>
            </Modal>
        </LuneThemeProvider>
    )
}

export default SaveTemplateModal
